import React, { useState, useEffect } from "react";
import { selfserviceOrderdetails } from "../../redux/actions";
import { useLocation, useNavigate } from "react-router-dom";

const TrackOrders = () => {
  const [orders, setOrders] = useState([]);
  const [error, setError] = useState(null);

  const location = useLocation();
  const id = location.state?.action;
  const navigate = useNavigate();

  // Fetch orders whenever orderType changes
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await selfserviceOrderdetails(id);
        setOrders(data || []); // Ensure orders exist
      } catch (err) {
        setError(err.message);
      }
    };

    fetchOrders();
  }, [id]);

  const steps = [
    { label: "Ordered : 29.01.2025" },
    { label: "Processed" },
    { label: "Shipped" },
    { label: "Delivered" },
    { label: "Invoice paid" },
  ];

  const orderStatus = orders?.status; // example value, could be "ordered", "processed", "shipped", "delivered", "invoice-paid"

  // Create a mapping between statuses and step numbers
  const statusMapping = {
    ordered: 1,
    processed: 2,
    shipped: 3,
    delivered: 4,
    "invoice-paid": 5,
  };

  // Set the active step based on the order status, defaulting to 1 if the status is not found
  const activeStep = statusMapping[orderStatus] || 1;

  if (orders?.order_products && orders.order_products.length > 0) {
    return (
      <section className="hot-deals pt-20">
        {/* component 1 about us*/}
        <div className="container container-lg">
          <div className="section-heading">
            <div className="d-flex align-items-center justify-content-between gap-0 w-100">
              {/* Left Button */}
              {/* <a href="/self-service/orders"> */}
              <button
                onClick={() => navigate(-1)}
                className="ph ph-arrow-left animated-caret w-52 h-52 bg-main-600 text-white text-xl hover-bg-main-600 hover-text-white flex-center"
              ></button>
              {/* </a> */}
              {/* Heading in the Center */}
              <h2 className="mb-0 text-blue flex-grow-1">
                &nbsp;&nbsp;ORDER{" "}
                {(orders?.created_at &&
                  new Date(orders?.created_at)
                    .toLocaleDateString("en-GB")
                    .replace(/\//g, ".")) ||
                  "-"}
              </h2>
            </div>
          </div>
        </div>
        <div className="tracking-timeline-wrapper">
          {/* Continuous background line */}
          <div className="tracking-line-container">
            <div className="tracking-line"></div>
          </div>

          {/* Step circles with labels */}
          <div className="tracking-steps">
            {steps.map((step, index) => (
              <div key={index} className="tracking-step">
                {index < activeStep ? (
                  // Active step: animated check circle with white fill
                  <svg
                    className="check-icon"
                    width="55"
                    height="55"
                    viewBox="0 0 80 80"
                  >
                    <circle
                      className="check-circle"
                      fill="white"
                      stroke="#4caf50"
                      strokeWidth="10"
                      cx="35"
                      cy="35"
                      r="30"
                    />
                    <path
                      className="check-mark"
                      fill="none"
                      stroke="#4caf50"
                      strokeWidth="4"
                      d="M22 37 l8 8 l18 -18"
                    />
                  </svg>
                ) : (
                  // Inactive step: static gray circle
                  <svg
                    className="inactive-icon"
                    width="40"
                    height="40"
                    viewBox="0 0 70 70"
                  >
                    <circle
                      className="inactive-circle"
                      fill="#ccc"
                      stroke="#ccc"
                      strokeWidth="4"
                      cx="35"
                      cy="35"
                      r="30"
                    />
                  </svg>
                )}
                <div className="step-label">{step.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="container container-lg ">
          <div className="tab-content" id="pills-tabContent">
            <div className="container container-lg ">
              <div className="row gy-4">
                {/* grid for orders */}
                <div className="col-sm-5 ">
                  <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                    <div className="py-xl-4">
                      <h4 className="text-blue mb-8">Shipping</h4>
                    </div>
                    <div>
                      <div>
                        <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                          <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                            <p className="text-blue m-0">
                              <b>{orders?.company?.name}</b>
                            </p>
                            <p className="text-blue m-0">
                              {[
                                orders?.location?.delivery_address
                                  ?.address_line_1,
                                orders?.location?.delivery_address
                                  ?.address_line_2,
                                orders?.location?.delivery_address
                                  ?.address_line_3,
                              ]
                                .filter(Boolean) // Removes empty or undefined values
                                .join(", ")}
                            </p>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                    <div className="py-xl-4">
                      <h4 className="text-blue mb-8">Payments</h4>
                    </div>
                    <div>
                      <div>
                        <div className="flex-align gap-8 d-flex justify-content-between w-100 p-16 bg-light-grey rounded-16 mb-32">
                          <span className="text-sm text-white">
                            <p className="text-black">Payment status</p>
                            <p className="text-black">
                              <b>{orders?.payments[0]?.status}</b>
                            </p>
                          </span>
                        </div>
                        <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                          <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                            <p className="text-black m-0">Payment type</p>
                          </span>
                          <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                            <p className="text-black m-0">
                              {orders?.payments[0]?.method}
                            </p>
                          </span>
                        </div>
                        <hr></hr>
                        <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                          <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                            <p className="text-black m-0">Payment date</p>
                          </span>
                          <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                            <p className="text-black m-0">-</p>
                          </span>
                        </div>
                        <hr></hr>
                        <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                          <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                            <p className="text-black m-0">Invoice issued</p>
                          </span>
                          <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                            <p className="text-black m-0">-</p>
                          </span>
                        </div>
                        <br></br>
                        <button className="w-100 p-10  text-xl bg-main-product-50 text-white  hover-bg-main-product-50 hover-text-white flex-center rounded-10 mb-32">
                          Download Invoice (Not Implemented)
                        </button>
                      </div>
                    </div>
                  </div>
                  <br></br>
                  {/* <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                    <div>
                      <div>
                        <button className="w-100 p-10 bg-main-50 text-main-600 text-xl hover-bg-main-600 hover-text-white flex-center rounded-6 mb-32">
                          Add all to shopping cart
                        </button>
                      </div>
                    </div>
                  </div> */}
                </div>
                <div className="col-sm-7">
                  <div className="border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
                    <div className="py-xl-4">
                      <h4 className="text-blue ack mb-8">Products</h4>
                      <hr></hr>
                      <div className="col-xxl-12 col-lg-12 col-sm-6">
                        <div className="p-16  rounded-16 position-relative transition-2 ">
                          <div className="short-product-list arrow-style-two">
                            <div>
                              {orders?.order_products &&
                                orders?.order_products.length > 0 &&
                                orders?.order_products.map((data, index) => (
                                  <>
                                    {" "}
                                    {/* React Fragment */}
                                    <div
                                      key={index}
                                      className="border border-gray-100 hover:border-main-600 grid grid-cols-3 items-center gap-4 p-4"
                                    >
                                      {/* Image Column */}
                                      <div className="flex-shrink-0">
                                        <img
                                          src={
                                            data?.product_variation?.images?.[0]
                                              ?.files?.small?.url ||
                                            "/assets/images/logo/Image-coming-soon.png"
                                          }
                                          alt=""
                                          className="w-50 h-70 object-cover"
                                        />
                                      </div>

                                      {/* Name Column */}
                                      <div className="min-w-0">
                                        <h6 className="text-lg font-semibold truncate">
                                          {data?.product_variation?.name}
                                        </h6>
                                        <span className="text-heading text-md block truncate">
                                          Quantity: {data?.qty}
                                        </span>
                                      </div>

                                      {/* Price Column (Aligned to Right) */}
                                      <div className="text-center">
                                        <h6 className="text-blue font-semibold whitespace-nowrap">
                                          {orders?.order_products[0]?.currency}{" "}
                                          {orders?.order_products[0]
                                            ?.original_gross_price * data?.qty}
                                        </h6>
                                      </div>
                                    </div>
                                    <br />
                                  </>
                                ))}
                            </div>
                          </div>
                        </div>
                        <hr></hr>
                        <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                          <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                            <p className="text-black m-0">Subtotal</p>
                          </span>
                          <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                            <p className="text-black m-0">
                              {orders?.order_products[0]?.currency}{" "}
                              {orders?.total_gross_price?.toFixed(
                                orders?.order_products[0]?.currency === "OMR"
                                  ? 3
                                  : 2
                              )}
                            </p>
                          </span>
                        </div>
                        <hr></hr>
                        <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                          <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                            <p className="text-black m-0">VAT</p>
                          </span>
                          <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                            <p className="text-black m-0">
                              {orders?.order_products[0]?.currency}{" "}
                              {orders?.vat_amount?.toFixed(
                                orders?.order_products[0]?.currency === "OMR"
                                  ? 3
                                  : 2
                              )}
                            </p>
                          </span>
                        </div>
                        <hr></hr>
                        <div className="d-flex flex-wrap w-100 p-2 align-items-start">
                          <span className="text-sm text-white w-50 w-sm-100 text-start d-inline-block">
                            <p className="text-black m-0">Total amount</p>
                          </span>
                          <span className="text-sm text-main-two-600 w-50 w-sm-100 text-start d-flex align-items-start">
                            <p className="text-black m-0">
                              <b>
                                {orders?.order_products[0]?.currency}{" "}
                                {orders?.total_net_price?.toFixed(
                                  orders?.order_products[0]?.currency === "OMR"
                                    ? 3
                                    : 2
                                )}
                              </b>
                            </p>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default TrackOrders;
